import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import { connect } from 'react-redux';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import SettingsPanel from "./settingsPanel";
import { appConstants } from '../../_constants';
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services/common.service";
import TableStructure from "./emailTable";
import UpdateModal from "./UpdateModal";
import CircularProgress from "../../utils/CircularProgress";
import { store } from "../../_store";
//import Edit from "@material-ui/icons/Edit";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    wide: {
        width: "100%",
        minWidth: "300px"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    negativeColor: {
        color: "red"
    },
    icon: {
        margin: "8px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    },
    edit: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center"
    },
    positiveColor: {
        color: "green"
    }
};

class EmailSettings extends React.Component {
    state = {
        page: 0,
        rowsPerPage: 10,
        airlines: "",
        activeEditEmail: -1,
        activeEditMobileNumber: -1,
        records: [],
        selectValue: " ",
        open: false,
        isOpen: false,
        emails: '',
        email: '',
        editedEmails: [],
        additionalEmails: "",
        editedMobileNumbers: [],
        additionalMobileNumbers: "",
        mobileNumbers: "",
        NotificationTypeId: "-1",
        airlineName: "",
        airlinesData: [],
        notificationType: [],
        recordId: "",
        airline: "-1",
        airlineId: "-1",
        requestingData: true,
        Id: "",
        PageCount: 10,
        CurrentPage: 1,
        TotalCount: 0,
        notificationErrorComponent: false,
        numberErrorComponent: false,
        emailErrorComponent: false,
        airlineErrorComponent: false,
        airportErrorComponent: false,
        notificationErrorMessage: '',
        emailErrorMessage: '',
        numberErrorMessage: '',
        pageRequesting: true,
        user: '',
        airportCode: "-1",
        airportCode2: "-1",
        airports: []
    };

    componentDidMount() {
        let { airlines, airports, dispatch } = this.props;
        const { user } = store.getState();
        if (airlines) {
            this.setState({ user, airlinesData: airlines })
        } else {
            this.fetchAirline();
        }
        if (airports) {
            this.setState({ airports })
        } else {
            dispatch(commonActions.getAllAirports());
        }
        if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ airportCode2: userLocation, airportCode: userLocation }, this.getNotificationEmail);
        } else if (user.Location) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ airportCode2: userLocation, airportCode: userLocation }, this.getNotificationEmail);
        }
        else if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = { ...user };
            let userAirline = { value: userObj.AirlineId, label: userObj.AirlineName };
            this.setState({ AirlineId: userAirline }, this.getNotificationEmail);
        } else if (user.Location) {
            this.setState({ airportCode2: user.AirportCode, airportCode: user.AirportCode }, this.getNotificationEmail)
        }
        else {
            this.getNotificationEmail()
        }
        this.getNotificationType()

    }
    //Get Notification Type
    getNotificationType = () => {
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.getNotificationType()
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let NotificationType = [];
                    let data = res.response
                    for (const [key, value] of Object.entries(data)) {
                        NotificationType.push({
                            type: value,
                            value: Number(key)
                        });
                    }
                    // console.log({ NotificationType })
                    this.setState({ pageRequesting: false, notificationType: NotificationType })
                }

                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }

            })
            .catch(err => {
                dispatch(alertActions.error(err.response));
            })
        dispatch(alertActions.clear())
    }



    componentWillReceiveProps = function (nextProps) {
        const { airlines, airports } = nextProps;
        if (airlines) {
            let modifiedAirline = [...airlines];
            let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
            modifiedAirline.unshift(allAirlines);
            this.setState({ airlinesData: modifiedAirline });
        }
        if (airports) {
            let modifiedAirport = [...airports];
            modifiedAirport.unshift({ Name: "All Airports", Code: "-1" });
            this.setState({ airports: modifiedAirport });
        }
    };

    fetchAirline = () => {
        const { dispatch } = this.props;
        dispatch(commonActions.getAllAirlines());

    };

    filterAirlines = (airlineId) => {
        // return userId;
        const { airlinesData } = this.state;
        let airlineName = airlinesData.find(u => u.AirlineId === airlineId);
        if (airlineName) {
            return `${airlineName.Airline}`
        } else {
            return (airlineId === 0) ? 'All Airlines' : 'Unknown Airline';
        }
    };

    filterNotificationType = (value) => {
        const { notificationType } = this.state;
        let notificationName = notificationType.find(notification => notification.value === value);
        if (notificationName) {
            return `${notificationName.type}`
        } else {
            return (value === 0) ? 'All Notifications' : 'Unknown Notification';
        }
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleEdit = (record) => {
        let { AirlineId, Airline, NotificationTypeId, Email, Id, MobileNo, AirportCode } = record;

        let editedEmail;
        editedEmail = Email.split(",");

        let editedMobileNumbers;
        editedMobileNumbers = (MobileNo) ? MobileNo.split(",") : "";

        this.setState({
            open: true,
            airlineId: AirlineId,
            airportCode2: AirportCode,
            airlineName: Airline,
            recordId: Id,
            NotificationTypeId: NotificationTypeId,
            editedEmail: editedEmail,
            editedMobileNumbers,
            additionalEmails: '',
            additionalMobileNumbers: '',
        })
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1") {
            this.setState({ [name.name]: "-1" })
        }
    };

    handleChangeEmail = (event, index) => {
        const value = event.target.value;
        const { editedEmail } = this.state;
        editedEmail[index] = value;
        this.setState({ editedEmail });
    };

    handleChangeMobileNumber = (event, index) => {
        const value = event.target.value;
        const { editedMobileNumbers } = this.state;
        editedMobileNumbers[index] = value;
        this.setState({ editedMobileNumbers });
    };

    //Edit Current Email
    handleActiveInput = (emails, i, mode) => {
        if (mode === 1) {
            this.setState({ activeEditEmail: i });
        } else if (mode === 2) {
            this.setState({ activeEditMobileNumber: i });
        }
    };


    //Edit Emails
    handleSave = () => {
        let { airportCode2, additionalEmails, editedEmail, editedMobileNumbers, additionalMobileNumbers, recordId, airlineId, NotificationTypeId } = this.state;
        const { dispatch, user } = this.props;

        editedMobileNumbers = editedMobileNumbers ? editedMobileNumbers : [];
        editedEmail = editedEmail ? editedEmail : [];

        let Email = editedEmail.join();
        if (additionalEmails !== '') {
            Email = (editedEmail.length) ?
                additionalEmails.concat("," + editedEmail.join()) :
                additionalEmails
        }

        let MobileNo;
        if (additionalMobileNumbers === '') {
            MobileNo = editedMobileNumbers.join();
        } else {
            MobileNo = (editedMobileNumbers.length) ?
                additionalMobileNumbers.concat("," + editedMobileNumbers.join()) :
                additionalMobileNumbers
        }

        let payload = {
            "Id": recordId,
            "NotificationTypeId": NotificationTypeId,
            "AirlineId": airlineId,
            "AirportCode": airportCode2,
            Email,
            MobileNo
        };

        dispatch(alertActions.startRequest());
        commonService.editNotification(payload)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
                else if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify("Edited Successfully"))
                    this.getNotificationEmail()
                    this.setState({ open: false, activeEditEmail: -1, additionalEmails: "", airportCode2: user.AppRole })
                }

            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            })
        dispatch(alertActions.clear())
    };

    //Displays Airport Name
    filterAirport = (airportCode) => {
        const { airports } = this.state;
        let result = airports.find(item => item.Code === airportCode);
        let name = result ? result.Name : "Unknown Airport"
        return name
    }

    getNotificationEmail = (pageNumber = 1) => {
        const { dispatch } = this.props;
        const { PageCount, airline, airportCode } = this.state;

        let Airline = (airline === "-1") ? "" : airline.value;
        let AirportCode = (airportCode === "-1") ? "" : airportCode.value;

        dispatch(alertActions.startRequest());
        commonService.searchNotificationEmail(Airline, AirportCode, pageNumber, PageCount)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        pageRequesting: false,
                        CurrentPage: pageNumber,
                        TotalCount: res.response.TotalCount,
                        records: res.response
                    });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            });
        dispatch(alertActions.clear())
    }

    //close modal
    handleClose = () => {
        this.setState({
            open: false,
            isOpen: false,
            notificationErrorComponent: false,
            numberErrorComponent: false,
            airlineErrorComponent: false,
            airportErrorComponent: false,
            emailErrorComponent: false
        })
    };

    handleSelect = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }


    //add Email Notification
    handleSubmit = () => {
        const { dispatch } = this.props;
        const { user } = this.state;
        const { airlineId, addEmails, NotificationTypeId, mobileNumbers, airportCode2 } = this.state;
        let payload = {
            "id": 0,
            "AirlineId": airlineId.value,
            "NotificationTypeId": NotificationTypeId.value,
            "Email": addEmails,
            "AirportCode": airportCode2.value,
            CreatedBy: user.userId,
            MobileNo: mobileNumbers
        };

        const valid = () => {
            if (NotificationTypeId === "-1") {
                this.setState({ notificationErrorComponent: true })
                return false;
            }
            if (airlineId === "-1") {
                this.setState({ airlineErrorComponent: true })
                return false;
            }
            if (airportCode2 === "-1") {
                this.setState({ airportErrorComponent: true })
                return false;
            }
            if (addEmails === "") {
                this.setState({ emailErrorComponent: true })
                return false;
            }
            if (mobileNumbers === "") {
                this.setState({ numberErrorComponent: true })
                return false;
            }
            return true
        };


        if (valid()) {
            dispatch(alertActions.startRequest());
            this.setState({ numberErrorComponent: false, emailErrorComponent: false, airlineErrorComponent: false, airportErrorComponent: false, notificationErrorComponent: false })
            commonService.addEmailNotification(payload)
                .then(res => {
                    dispatch(alertActions.stopRequest());
                    if (res.status === appConstants.ERROR_RESPONSE) {
                        dispatch(alertActions.error(res.response));
                    }
                    else if (res.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(alertActions.notify("Added Successfully"));
                        // dispatch(alertActions.notify(res.response));
                        this.setState({ isOpen: false, editErrorComponent: false, errorMessage: "", NotificationTypeId: "", airlineId: "", addEmails: "", airportCode2: user.AppRole, mobileNumbers: "" });
                        this.getNotificationEmail()
                    }
                })
                .catch(err => {
                    dispatch(alertActions.error(err.response))
                })
            dispatch(alertActions.clear())
        }

    };

    //Add Threshold modal
    handleAdd = () => {
        this.setState({ isOpen: true })
    };

    filterUsers = (userId) => {
        const { users } = this.state;
        if (users) {
            let userName = users.find(u => u.Id === userId);
            if (userName) {
                return `${userName.FirstName} ${userName.LastName}`
            } else {
                return "Unknown User"; //`Unknown User`;
            }
        }
    }

    render() {
        const { classes, fullScreen, user, requesting } = this.props;
        const { airportCode2, airports, airportCode, airlineErrorComponent, airportErrorComponent, activeEditEmail, editedEmail, notificationErrorComponent, numberErrorComponent, emailErrorComponent, additionalEmails, activeEditMobileNumber, editedMobileNumbers, additionalMobileNumbers, pageRequesting, airline, airlineId, addEmails, NotificationTypeId, notificationType, isOpen, records, airlinesData } = this.state;

        if (pageRequesting)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <GridContainer>
                    <SettingsPanel
                        NotificationTypeId={NotificationTypeId.value}
                        notificationType={notificationType}
                        handleAdd={this.handleAdd}
                        airlineId={airlineId.value}
                        isOpen={isOpen}
                        notificationErrorComponent={notificationErrorComponent}
                        numberErrorComponent={numberErrorComponent}
                        airlineErrorComponent={airlineErrorComponent}
                        airportErrorComponent={airportErrorComponent}
                        emailErrorComponent={emailErrorComponent}
                        airline={airline.value}
                        addEmails={addEmails}
                        airlinesData={airlinesData}
                        handleChange={(event, name) => this.handleReactSelectChange(event, name)}
                        handleSearch={this.getNotificationEmail}
                        handleClose={this.handleClose}
                        handleSubmit={this.handleSubmit}
                        handleSelect={this.handleSelect}
                        airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
                        airportCode2={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode2 : airportCode2.value}
                        airports={airports}
                        user={user}
                        disabled={requesting}
                    />
                </GridContainer>


                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="success">

                                <h4 className={classes.cardTitleWhite}>Email Settings</h4>
                                {/* <p className={classes.cardCategoryWhite}>
                Here is a subtitle for this table
              </p> */}
                            </CardHeader>
                            <CardBody>
                                <div className={classes.tableResponsive}>
                                    <TableStructure
                                        notificationType={notificationType}
                                        airlinesData={airlinesData}
                                        filterNotificationType={this.filterNotificationType}
                                        records={records}
                                        handleEdit={this.handleEdit}
                                        classes={this.props.classes}
                                        totalCounts={this.state.TotalCount}
                                        filterUsers={this.filterUsers}
                                        currentPage={this.state.CurrentPage}
                                        pageSize={this.state.PageCount}
                                        user={this.props.user}
                                        filterAirline={this.filterAirlines}
                                        fetchRecords={this.getNotificationEmail}
                                        filterAirport={this.filterAirport}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>

                    <Dialog
                        fullScreen={fullScreen}
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="responsive-dialog-title"
                    >
                        {/*<DialogTitle id="responsive-dialog-title" style={{backgroundColor:"#66bb6a"}}>*/}
                        {/*<span style={{color:"white",textTransform:"uppercase"}}> {airlineName}</span>*/}
                        {/*</DialogTitle>*/}
                        <DialogContent>
                            <GridContainer style={{ padding: "0 15px" }}>
                                <UpdateModal
                                    classes={classes}
                                    handleSelect={this.handleSelect}
                                    user={user}
                                    airports={airports}
                                    airportCode2={airportCode2}
                                    record={airportCode2}
                                    additionalEmails={additionalEmails}
                                    additionalMobileNumbers={additionalMobileNumbers}
                                    handleChange={this.handleChange}
                                    editedEmail={editedEmail}
                                    editedMobileNumbers={editedMobileNumbers}
                                    activeEditEmail={activeEditEmail}
                                    activeEditMobileNumber={activeEditMobileNumber}
                                    handleActiveInput={this.handleActiveInput}
                                    handleChangeEmail={this.handleChangeEmail}
                                    handleChangeMobileNumber={this.handleChangeMobileNumber}
                                />

                            </GridContainer>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="danger">
                                Cancel
            </Button>
                            <Button onClick={this.handleSave.bind(this, 1)} color={'primary'} autoFocus>
                                Save
            </Button>
                        </DialogActions>
                    </Dialog>
                </GridContainer>
            </div>
        );
    }
}

EmailSettings.defaultProps = {
    tableHeaderColor: "gray"
};

EmailSettings.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeaderColor: PropTypes.oneOf([
        "warning",
        "primary",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    tableHead: PropTypes.arrayOf(PropTypes.string),
    tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

const mapStateToProps = state => {
    const { modal, alert, airports, airlines, progress, user, requesting } = state;
    return {
        modal,
        alert,
        airlines,
        progress,
        airports,
        user,
        requesting
    };
};

export default connect(mapStateToProps)(withStyles(styles)(EmailSettings));



// WEBPACK FOOTER //
// ./src/views/EmailSettings/Index.jsx